export default __webpack_public_path__ + "static/media/of_1.9b4ada23.mp3";